import { api } from '../core/api-client.js';
import { showNotification } from '../utils/notifications.js';

export async function loadProfile() {
    console.log('[Profile] Profile view loaded');
}

export async function handleProfileUpdate(event) {
    event.preventDefault();

    const id = document.getElementById('profile-id').value;
    const name = document.getElementById('profile-name').value;
    const email = document.getElementById('profile-email').value;
    const password = document.getElementById('profile-password').value;
    const confirmPassword = document.getElementById('profile-confirm-password').value;

    if (password && password !== confirmPassword) {
        showNotification("Passwords do not match!", "error");
        return;
    }

    const data = { name, email };
    if (password) data.password = password;

    const btn = event.submitter;
    const originalText = btn ? btn.innerHTML : '';

    try {
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Saving...';
        }

        await api.updateUser(id, data);

        showNotification("Profile updated successfully!", "success");

        setTimeout(() => {
            location.reload();
        }, 1000);

    } catch (error) {
        console.error(error);
        showNotification("Failed to update profile: " + (error.message || "Unknown error"), "error");

        if (btn) {
            btn.disabled = false;
            btn.innerHTML = originalText;
        }
    }
}

function setMFABadge(enabled, required) {
    const badge = document.getElementById('mfa-status-badge');
    if (!badge) return;
    if (enabled) {
        badge.textContent = 'Enabled';
        badge.className = 'text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded border border-neonGreen text-neonGreen';
    } else if (required) {
        badge.textContent = 'Required';
        badge.className = 'text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded border border-neonAmber text-neonAmber';
    } else {
        badge.textContent = 'Disabled';
        badge.className = 'text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded border border-slate-600 text-slate-400';
    }
}

function showMFAPanels(enabled) {
    const enabledPanel = document.getElementById('mfa-enabled-panel');
    const disabledPanel = document.getElementById('mfa-disabled-panel');
    if (enabledPanel) enabledPanel.classList.toggle('hidden', !enabled);
    if (disabledPanel) disabledPanel.classList.toggle('hidden', enabled);
}

export async function initProfileMFA() {
    const section = document.getElementById('mfa-section');
    if (!section) return;

    try {
        const status = await api.getMFAStatus();
        setMFABadge(!!status.mfa_enabled, !!status.required);
        showMFAPanels(!!status.mfa_enabled);

        const hint = document.getElementById('mfa-required-hint');
        if (hint) {
            hint.textContent = status.required
                ? 'Organization policy requires MFA. Enable Google Authenticator to stay compliant.'
                : 'Optional: add an authenticator app for stronger account security.';
        }
    } catch (e) {
        console.warn('[Profile] MFA status failed:', e);
        setMFABadge(false, false);
        showMFAPanels(false);
    }

    const startBtn = document.getElementById('mfa-start-btn');
    if (startBtn) {
        startBtn.addEventListener('click', async () => {
            try {
                startBtn.disabled = true;
                const setup = await api.setupMFA();
                const qr = document.getElementById('mfa-profile-qr');
                const secret = document.getElementById('mfa-profile-secret');
                const enroll = document.getElementById('mfa-enroll-panel');
                if (qr) qr.src = setup.qr_code || '';
                if (secret) secret.textContent = setup.secret || '';
                if (enroll) enroll.classList.remove('hidden');
            } catch (e) {
                showNotification(e.message || 'Failed to start MFA setup', 'error');
            } finally {
                startBtn.disabled = false;
            }
        });
    }

    const confirmBtn = document.getElementById('mfa-confirm-btn');
    if (confirmBtn) {
        confirmBtn.addEventListener('click', async () => {
            const code = (document.getElementById('mfa-enable-code') || {}).value || '';
            try {
                confirmBtn.disabled = true;
                await api.enableMFA(code.trim());
                showNotification('MFA enabled successfully', 'success');
                setTimeout(() => location.reload(), 800);
            } catch (e) {
                showNotification(e.message || 'Failed to enable MFA', 'error');
                confirmBtn.disabled = false;
            }
        });
    }

    const disableBtn = document.getElementById('mfa-disable-btn');
    if (disableBtn) {
        disableBtn.addEventListener('click', async () => {
            const code = (document.getElementById('mfa-disable-code') || {}).value || '';
            const password = (document.getElementById('mfa-disable-password') || {}).value || '';
            try {
                disableBtn.disabled = true;
                await api.disableMFA(code.trim(), password);
                showNotification('MFA disabled', 'success');
                setTimeout(() => location.reload(), 800);
            } catch (e) {
                showNotification(e.message || 'Failed to disable MFA', 'error');
                disableBtn.disabled = false;
            }
        });
    }
}

window.handleProfileUpdate = handleProfileUpdate;
window.initProfileMFA = initProfileMFA;
